var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      ref: "modal",
      staticClass: "modal-wrap",
    },
    [
      _c("div", {
        staticClass: "modal-cover",
        on: { click: _vm.handleCloseBtnClick },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "modal" }, [
        _c(
          "div",
          { staticClass: "modal-content" },
          [
            _vm.showClose
              ? _c("div", {
                  staticClass: "modal-close",
                  on: {
                    click: function ($event) {
                      return _vm.handleCloseBtnClick("closeBtn")
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._t("modal-content"),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }